module.exports = __webpack_public_path__ + "static/img/thankyou_lead-form.fcdda5b.png";